export enum PlayType {
    Normal,
    PublishFollowBuy,
    FollowBuy,
    CustomizeFollowBuy,
    GroupBuy,
    ChaseNum,
    BonusOptimization,
}